<template>
	<router-view />
</template>

<script>
	import { getCurrentInstance, ref, computed, watch, onMounted, inject } from "vue";
	import { useRoute } from "vue-router";
	import store from "@/store";
	import config from "@/components/ckeditor/config";
	export default {
		title: "Boyden",
		setup() {
			config.vueContext = getCurrentInstance().appContext;

			const $http = inject("$http");
			const $store = inject("$store");
			const $route = useRoute();

			const appLoading = computed(() => {
				return $store.getters.appLoading;
			});

			//var refreshPromises = [];
			//var refreshing = false;
			// $http.interceptors.response.use(
			// 	(resp) => {
			// 		return resp;
			// 	},
			// 	async (err) => {
			// 		if (
			// 			err.response.status >= 401 &&
			// 			err.response.headers["token-expired"] == "true" &&
			// 			!refreshing
			// 		) {
			// 			refreshing = true;
			// 			return await new Promise((resolve, reject) => {
			// 				$http
			// 					.post("/api/v2/user/refresh", {})
			// 					.then(async (r) => {
			// 						if (r) {
			// 							$store.dispatch("login", r.data);
			// 							refreshing = false;
			// 							resolve($http.request(err.config));
			// 							refreshPromises = refreshPromises.map(async (config) => {
			// 								return await $http.request(config);
			// 							});
			// 						} else {
			// 							resolve(err.config);
			// 						}
			// 					})
			// 					.catch((e) => {
			// 						console.error("failed to refresh.");
			// 						$store.dispatch("logout");
			// 						reject(e);
			// 					});
			// 			});
			// 		} else if (refreshing) {
			// 			refreshPromises.push(err.config);
			// 		} else {
			// 			return Promise.reject(err);
			// 		}
			// 	}
			// );

			onMounted(() => {
				let meta = document.querySelector("meta[name='viewport']");
				if (!meta) {
					meta = document.createElement("meta");
					meta.name = "viewport";
					document.head.appendChild(meta.value);
				}

				meta.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
			});

			return {
				appLoading
			};
		}
	};
</script>
<style lang="scss" scoped>
	@use "@/assets/css/globalVars.scss" as *;

	.loading-overlay {
		@include reset-element;
		position: absolute;
		z-index: 100;
		display: block;
		background-color: $color-background;

		& > div {
			display: inline-block;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -130%);
		}

		& h2 {
			display: inline-block;
			color: white;
			font-size: 3rem;
			font-weight: 500;
			filter: blur(0.4px);
		}
	}

	$scale: 2;
	$interval: 0.6s;

	.lds-ellipsis {
		display: inline-block;
		position: relative;
		width: 6.153rem * $scale;
		height: 6.153rem * $scale;
	}

	.lds-ellipsis div {
		position: absolute;
		top: 5.2rem * $scale;
		width: 1rem * $scale;
		height: 1rem * $scale;
		border-radius: 50%;
		background: $boyden-blue-light;
		animation-timing-function: cubic-bezier(0, 1, 1, 0);
	}

	.lds-ellipsis div:nth-child(1) {
		left: 0.62rem * $scale;
		animation: lds-ellipsis1 $interval infinite;
	}

	.lds-ellipsis div:nth-child(2) {
		left: 0.62rem * $scale;
		animation: lds-ellipsis2 $interval infinite;
	}

	.lds-ellipsis div:nth-child(3) {
		left: 2.46rem * $scale;
		animation: lds-ellipsis2 $interval infinite;
	}

	.lds-ellipsis div:nth-child(4) {
		left: 4.3rem * $scale;
		animation: lds-ellipsis3 $interval infinite;
	}

	@keyframes lds-ellipsis1 {
		0% {
			transform: scale(0);
		}

		100% {
			transform: scale(1);
		}
	}

	@keyframes lds-ellipsis3 {
		0% {
			transform: scale(1);
		}

		100% {
			transform: scale(0);
		}
	}

	@keyframes lds-ellipsis2 {
		0% {
			transform: translate(0, 0);
		}

		100% {
			transform: translate(1.85rem * $scale, 0);
		}
	}
</style>
